import { useEffect, useRef } from "react"

function SkillItem(props) {

    const info = props.info
    const levelNames = new Map([
        [1, "Novice"],
        [2, "Beginner"],
        [3, "Intermediate"],
        [4, "Advanced"], 
        [5, "Expert"]
    ])
    const barHandle = useRef(null)

    useEffect(() => {
        //set bar level depending on skill level (scale from 1 to 5)
        let skillLevel = info.level > 5 ? 5 : Math.floor(info.level)
        skillLevel = skillLevel === 0 ? 1 : skillLevel
        const percentage = skillLevel / 5 * 100
        const bar = barHandle.current
        bar.style.clipPath = `polygon(0% 0, ${percentage}% 0, ${percentage}% 100%, 0% 100%)`
        
     }, [info.level])

    

    return (
        <div className="skill-item">
            <h2>
                {info.name}
            </h2>
            <p>Level: {levelNames.get(Math.floor(info.level))}</p>
            <div className="main-skills__meter-container">
                <div className="skill-meter" ref={barHandle}></div>
            </div>
        </div>
    )
    
}

export { SkillItem }